<ng-container *transloco="let t">
    <div class="dialog-container sai-dialog-shell data-source-usage-dialog">
        <app-sai-dialog-header
            icon="heroicons_outline:link"
            [title]="data.name || t('Data Source')"
            [subtitle]="t('Where used')"
            (closed)="close()"
        ></app-sai-dialog-header>

        <div class="dialog-body data-source-usage-dialog__body" [attr.aria-busy]="loading">
            @if (loading) {
                <div class="data-source-usage-dialog__state data-source-usage-dialog__loading">
                    <app-loading-spinner [loadingText]="t('Loading usage')"></app-loading-spinner>
                </div>
            } @else if (usage && sections.length === 0) {
                <div class="data-source-usage-dialog__state data-source-usage-dialog__empty">
                    <app-no-data-found
                        [compact]="true"
                        icon="heroicons_outline:inbox"
                        titleKey="Not used by any resources yet."
                    ></app-no-data-found>
                </div>
            } @else if (usage) {
                <div class="data-source-usage-dialog__content">
                    <div
                        class="sai-note data-source-usage-dialog__status"
                        [class.sai-note--success]="usage.canDelete"
                        [class.sai-note--warning]="!usage.canDelete"
                        role="status"
                    >
                        <mat-icon
                            class="sai-note__icon icon-size-5"
                            [svgIcon]="usage.canDelete ? 'heroicons_outline:check-circle' : 'heroicons_outline:exclamation-triangle'"
                            aria-hidden="true"
                        ></mat-icon>
                        <div class="sai-note__text">
                            {{ usage.canDelete ? t('Can be deleted') : t('Cannot be deleted until these are unlinked') }}
                        </div>
                    </div>

                    <div class="data-source-usage-dialog__sections">
                        @for (section of sections; track section.key) {
                            <section class="data-source-usage-dialog__section sai-card">
                                <header class="data-source-usage-dialog__section-head">
                                    <div class="data-source-usage-dialog__section-title">
                                        <span class="data-source-usage-dialog__section-icon" aria-hidden="true">
                                            <mat-icon class="icon-size-5" [svgIcon]="section.icon"></mat-icon>
                                        </span>
                                        <h3>{{ t(section.labelKey) }}</h3>
                                    </div>
                                    <span class="sai-badge sai-badge--quiet tabular-nums">
                                        {{ section.total }}
                                    </span>
                                </header>

                                @if (section.items.length > 0) {
                                    <ul class="data-source-usage-dialog__list">
                                        @for (item of section.items; track item.id) {
                                            <li class="data-source-usage-dialog__item">
                                                <span class="data-source-usage-dialog__item-dot" aria-hidden="true"></span>
                                                <span class="data-source-usage-dialog__item-name">{{ item.name }}</span>
                                            </li>
                                        }
                                    </ul>
                                    @if (section.moreCount > 0) {
                                        <p class="data-source-usage-dialog__more">
                                            {{ t('+{{count}} more', { count: section.moreCount }) }}
                                        </p>
                                    }
                                }
                            </section>
                        }
                    </div>
                </div>
            }
        </div>

        <div class="dialog-footer data-source-usage-dialog__footer">
            <button mat-flat-button type="button" class="bg-primary" (click)="close()">
                {{ t('Close') }}
            </button>
        </div>
    </div>
</ng-container>
